"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCohortSchema = exports.createCohortSchema = exports.cohortDtoSchema = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("../enums.js");
// ─── Master-library Cohort schemas ────────────────────────────────────────
// These mirror the Prisma Cohort model. We keep the legacy CohortLetters
// enum + maps in enums.ts as a fallback for code that already reads them,
// but the DB row (when present) is authoritative.
const groupServiceLikeSchema = zod_1.z.enum(enums_js_1.GroupServiceTypes);
const individualServiceLikeSchema = zod_1.z.enum(enums_js_1.IndividualServiceTypes);
// Short alphanumeric code (A, B, IOP-EVE, etc). We don't lock this to a
// single letter so an operator can add per-track variants without code change.
const codeSchema = zod_1.z
    .string()
    .min(1)
    .max(16)
    .regex(/^[A-Za-z0-9_-]+$/, 'Code must be alphanumeric (letters, digits, _ or -)');
exports.cohortDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    code: codeSchema,
    name: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().nullable().optional(),
    requiredGroups: zod_1.z.array(groupServiceLikeSchema),
    defaultIndividualServices: zod_1.z.array(individualServiceLikeSchema),
    maxCapacity: zod_1.z.number().int().positive().nullable().optional(),
    sortOrder: zod_1.z.number().int().default(100),
    active: zod_1.z.boolean().default(true),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.createCohortSchema = zod_1.z.object({
    code: codeSchema,
    name: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().nullable().optional(),
    requiredGroups: zod_1.z.array(groupServiceLikeSchema).default([]),
    defaultIndividualServices: zod_1.z.array(individualServiceLikeSchema).default([]),
    maxCapacity: zod_1.z.number().int().positive().nullable().optional(),
    sortOrder: zod_1.z.number().int().default(100),
    active: zod_1.z.boolean().default(true),
});
exports.updateCohortSchema = exports.createCohortSchema.partial();
//# sourceMappingURL=cohort.js.map